import type { ReactNode } from "react";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import { Badge } from "@mui/material";
import type CommandeArticleCartModel from "models/CommandeArticleCartModel";
import { useSelector } from "react-redux";
import type { StoreProps } from "store/store";
import type { ColorPaletteKey } from "providers";

type CartIconProps = {
  badge?: boolean;
  badgeColor?: ColorPaletteKey;
};

function CartIcon({ badge = true, badgeColor = "primary" }: Readonly<CartIconProps>): ReactNode {
  const cart = useSelector<StoreProps, Array<CommandeArticleCartModel>>((state) => state?.cart);

  if (badge) {
    return (
      <Badge
        badgeContent={cart.length}
        sx={{
          "& .MuiBadge-badge": {
            right: -3,
            top: 5,
            border: `2px solid white`,
            padding: "0 4px",
            backgroundColor: "white",
            color: `${badgeColor}.main`,
          },
        }}>
        <ShoppingBasketIcon />
      </Badge>
    );
  }
  return <ShoppingBasketIcon />;
}

export default CartIcon;
